import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { environment } from '@env'
import { Competition, MatchDayResponse, Season } from '@core/models/season-competition.models'

@Injectable({ providedIn: 'root' })
export class SeasonApi {
  private readonly _http: HttpClient = inject(HttpClient)

  fetchMatchDaysBySeasonAndCompetition(season: Season, competition: Competition): Observable<MatchDayResponse> {
    return this._http.get<MatchDayResponse>(
      `${environment.apiDomain}/matchdays/seasons/${season.id}/competitions/${competition?.id}`
    )
  }
}
